import { Config as ConfigModel } from '../../models/dashboard/config';
import { Options } from '../../models/dashboard/options';
import { State as ReportState } from './reducers-report';
import { reducer as optionsReducer } from './reducers-options';
import { reducer as reportReducer } from './reducers-report';

export interface State {
  options: Options;
  report: ReportState;
}
export interface Config {
  isLoading: boolean;
  config: ConfigModel;
}
export interface CombinedState {
  config: Config;
  options: Options;
  report: ReportState;
}

/* eslint-disable */
export function reducer(state: State, action: any): State {
  return {
    options: optionsReducer(state && state.options, action),
    report: reportReducer(state && state.report, action)
  };
}
